<template>
  <v-app>
    <v-container>

      <v-row align-self-center class="d-flex flex-column justify-center text-center" v-if="value.data.length === 0">
        <v-row class="justify-center pt-6">
          <v-img

              src="media/empty/empty-list.png"
              max-height="200"
              max-width="200"
          />

        </v-row>
        <p>
                <span>
                  {{$t('LISTS.NoData')}}
                </span>
        </p>
      </v-row>

      <slot v-bind="value.data[0]" v-else></slot>
      <hr>
      <v-row class="px-2">
        <v-col class="d-flex justify-start">
          <v-pagination
              v-model="value.current_page"
              class="align-end"
              :length="value.last_page"
              total-visible="10"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              :disabled="disabled"
          ></v-pagination>
        </v-col>
        <v-col class="text-end">
          <span class="text--disabled"> {{ value.current_page }} / {{ value.last_page }}</span>
        </v-col>

      </v-row>
    </v-container>

  </v-app>
</template>

<script>
export default {
  name: "SinglePaginate",
  props:{
    value : {
      type: Object,
      default : {
        current_page : 0,
        last_page : 0,
        data:[]
      }
    },
    disabled : false
  },
  data(){
    return {
      dSlot : {
        text : "salam"
      }
    }
  },
  watch:{
    'value.current_page'(){
      this.$emit('changePage', this.value.current_page)
    }
  },
}
</script>

<style scoped>

</style>